import React from "react";
import Pagination from "@streeteasy/design-system/legacy/Pagination";
import { arrayOf, bool, func, instanceOf, number } from "prop-types";

import Deal from "../../utilities/Deal";
import DealsByType from "../../utilities/DealsByType";
import DealRow from "../DealRow";
import * as S from "./styled";

const Table = ({
  currentPage,
  deals,
  isLoading,
  onChange,
  pageSize,
  totalCount,
  totalPages
}) => {
  const TableOverlay = isLoading ? S.LoadingOverlay : React.Fragment;

  return (
    <TableOverlay>
      <S.DealTable>
        <tbody>
          {deals.map(deal => (
            <DealRow key={deal.id} deal={deal} />
          ))}
        </tbody>
      </S.DealTable>
      {totalCount > 1 && totalPages > 1 ? (
        <Pagination
          current={currentPage}
          defaultCurrent={1}
          onChange={onChange}
          pageSize={pageSize}
          total={totalCount}
        />
      ) : null}
    </TableOverlay>
  );
};

Table.propTypes = {
  currentPage: number.isRequired,
  deals: arrayOf(instanceOf(Deal)).isRequired,
  isLoading: bool.isRequired,
  onChange: func.isRequired,
  pageSize: number,
  totalCount: number.isRequired,
  totalPages: number.isRequired
};

Table.defaultProps = {
  pageSize: DealsByType.PAGE_SIZE
};

export default Table;
